import { render, staticRenderFns } from "./CrearCampoDatosModal.vue?vue&type=template&id=d34bd9d8&"
import script from "./CrearCampoDatosModal.vue?vue&type=script&lang=ts&"
export * from "./CrearCampoDatosModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports